var searchHandleBarsTemplate = null;
var findNearestSearchType = "findYourNearest";
var usingCurrentLocText = "USING CURRENT LOCATION";
var searchParams = {};
var isNHSFife = false;

function initFindNearest(_isNHSFife) {
    console.log('initFindNearest');

    var searchAlreadyRun = false;
    if (isNHSFife != undefined) {
        isNHSFife = _isNHSFife;
    }
    const urlParams = new URLSearchParams(window.location.search);
    var serviceTypeParam = urlParams.get('serviceType');
    var postcodeParam = urlParams.get('postcode');
    var latInput = document.getElementById("currentLat");
    var lngInput = document.getElementById("currentLong");
    var latParam = urlParams.get('currentLat');
    var lngParam = urlParams.get('currentLong');
    var serviceTypeInput = document.getElementById("chooseservice");
    var postcodeInput = document.getElementById("localSearchPostcode");
    var runSearch = false;
    //console.log("Query string: service type: %o postcode: %o", serviceTypeParam, postcodeParam);
    if (serviceTypeParam != null) {
        //console.log(" service type: %o", serviceTypeParam);
        serviceTypeInput.value = serviceTypeParam;
    }
    if (postcodeParam != null) {
        postcodeParam = postcodeParam.toUpperCase();
        postcodeInput.value = postcodeParam;
    }
    if (latParam != null && lngParam != null) {
        postcodeInput.value = usingCurrentLocText;
    }
    if (latParam != null) {
        latInput.value = latParam;
    }
    if (lngParam != null) {
        lngInput.value = lngParam;
    }
    if ((postcodeParam != null && serviceTypeParam != null) || (latParam != null && lngParam != null && serviceTypeParam != null)) {
        runSearch = true;
    }

    // Run if it's a post
    //if (document.getElementById("localSearchPostcode").value != '' || document.getElementById("localSearchPostcode").value != 'empty') {
    //    //console.log('findNearestSubmit post');
    //    searchAlreadyRun = true;
    //    findNearestSubmit();
    //}

    if (runSearch == true && searchAlreadyRun == false) {
        //console.log('findNearestSubmit runSearch');
        findNearestSubmit();
    }
    serviceTypeInput.addEventListener('change', function (e) {
        var params = new URLSearchParams(window.location.search);

        e.target.value != "empty" ? params.set("serviceType", e.target.value) : params.delete("serviceType");

        var sparam = '' + params;
        if (sparam !== '') {
            window.history.replaceState({}, '', window.location.pathname + '?' + params);
        } else {
            window.history.replaceState({}, '', window.location.pathname);
        }
    });
    $("#testButton").click(function (event) {
        alert("clicked");
    });
    $("#find-nearest__submit").click(function (event) {
        event.preventDefault();
        var params = new URLSearchParams(window.location.search);

        if (validateForm() == true) {
            postcodeInput.value != "" ? params.set("postcode", postcodeInput.value) : params.delete("postcode");

            var sparam = '' + params;
            if (sparam !== '') {
                window.history.replaceState({}, '', window.location.pathname + '?' + params);
            } else {
                window.history.replaceState({}, '', window.location.pathname);
            }

            findNearestSubmit();
        }
        else {
            $('.find-nearest__error').css('display', 'inline-block').html('<p>Please enter your location and service type.</p>');
            $('#nearestSearchResults').html('<br /><p><b>Please enter a postcode and service to the form above to search.</b></p><br />');
        }
    });
    $("#find-nearest__submit__post").click(function (event) {
        //console.log("#find-nearest__submit__post");
        event.preventDefault();
        buildServiceSearchParams("$(\"#find - nearest__submit__post\").click(function (event) {}");
        document.location.href = $('#find-nearest-form').prop('action') + "?postcode=" + $('#localSearchPostcode').val() + "&serviceType=" + $('#chooseservice').val();
    });

    $("#find-nearest__submit__simple").click(function (event) {
        event.preventDefault();
        // console.log("#find-nearest__submit__simple");

        //console.log("path: %o", window.location.pathname);

        var params = new URLSearchParams(window.location.search);
        var serviceTypeInputSimple = document.getElementById("chooseservice");
        var postcodeInputSimple = document.getElementById("localSearchPostcode");

        postcodeInputSimple.value != "" ? params.set("postcode", postcodeInputSimple.value) : params.delete("postcode");
        serviceTypeInputSimple.value != "empty" ? params.set("serviceType", serviceTypeInputSimple.value) : params.delete("serviceType");
        var sparam = '' + params;
        if (sparam !== '') {
            window.history.replaceState({}, '', '/services/find-your-nearest/' + '?' + params);
        } else {
            window.history.replaceState({}, '', window.location.pathname);
        }
        window.location.href = "/services/find-your-nearest/?" + params;
        //  findNearestSubmitPost();
    });

    // Handles the current location button click
    $(".find-nearest__location").click(function (event) {
        event.preventDefault();
        var params = new URLSearchParams(window.location.search);

        latInput.value != "" ? params.set("currentLat", latInput.value) : params.delete("currentLat");
        lngInput.value != "" ? params.set("currentLong", lngInput.value) : params.delete("currentLong");

        var sparam = '' + params;
        if (sparam !== '') {
            window.history.replaceState({}, '', '/services/find-your-nearest/' + '?' + params);
        } else {
            window.history.replaceState({}, '', window.location.pathname);
        }

        var service = $("#chooseservice").val();

        $("#localSearchPostcode").prop('placeholder', 'Fetching location...');
        console.log('Started get geo : %o', new Date().getTime() / 1000);

        if (navigator.geolocation) {
            var location = navigator.geolocation.getCurrentPosition(
                function (position) {
                    $("#localSearchPostcode").val(usingCurrentLocText);

                    //console.log('Got results get geo : %o', new Date().getTime() / 1000);

                    var coords = position.coords;
                    var lat = coords.latitude;
                    var long = coords.longitude;

                    $("#localSearchPostcode").addClass('form-group__input--inactive');
                    $("#currentLat").val(lat);
                    $("#currentLong").val(long);

                    buildServiceSearchParams('$(".find-nearest__location").click()');

                    // Do we do an in place search or a post. Check the form id

                    if (service !== "empty") {
                        if ($('#find-nearest__submit__post').length === 1) {
                            findNearestSubmitPost();
                        } else {
                            findNearestSubmit();
                        }
                    }
                }, function (error) {
                    console.log('Geo error : %o', error);
                    $("#localSearchPostcode").prop('placeholder', 'Postcode');
                    $('.find-nearest__error').css('display', 'inline-block').html('<p>Unable to get location : ' + error.message + "</p><p>Please enter your postcode manually.</p>");
                });
        }
    });
}

function findNearestSubmitPost() {
    //event.preventDefault();
    var validation = validateForm();
    if (validation) {
        // buildServiceSearchParams('findNearestSubmitPost');
        // $('#find-nearest-form').submit();

        return;
    }
}

function findNearestSubmit() {
    $('#nearestSearchResults').html('Searching...');
    //event.preventDefault();
    var validation = validateForm();
    if (validation) {
        var prom = fetchSearchResults();
        var html = "";
        prom.then(
            function (result) {
                //processResults(result);
            }

        );
    } else {
        $('.find-nearest__error').css('display', 'inline-block').html('<p>Please enter your location and service type.</p>');
        $('#nearestSearchResults').html('<br /><p><b>Please enter a postcode and service to the form above to search.</b></p><br />');
    }
}

function validateForm() {
    var postcode = $("#localSearchPostcode").val();
    var service = $("#chooseservice").val();
    var passed = true;
    var error = "";

    if (postcode === "") {
        passed = false;
    }
    if (service === "empty") {
        passed = false;
    }

    if (passed) {
        $(".find-nearest__error").removeClass('find-nearest__error--show');
        $(".find-nearest__error").html("");
    } else {
        $(".find-nearest__error").addClass('find-nearest__error--show');
        $(".find-nearest__error").html("<p>Please fill in the postcode and service fields.</p>");
    }

    return passed;
}

function processResults(result) {
    if (result.Status === "Error" || result.length < 1) {
        $('.loading-overlay').addClass('loading-overlay--hide');
        html = "<p> Sorry, no results were found. </p>";
        if (result.Details !== null && result.Details !== undefined && result.Details !== '') {
            html = "<p style='color:red;'>Error -  " + result.Details + "</p>";
        }
        $('#nearestSearchResults').html(html);
    }
    else {
        console.log("Service nearest search results : %o", result.errorMessage);

        var resultCollection = {
            results: result,
            cookie: searchParams
        };

        //console.log('Obj to handlebars : %o', resultCollection);
        if (result.errorMessage != null && result.errorMessage != "") {
            var source = document.getElementById("nearestSearchTemplateError").innerHTML;
            searchHandleBarsTemplate = Handlebars.compile(source);
            html = searchHandleBarsTemplate(result.errorMessage);
            $('#nearestSearchResults').html(html);
        }
        else {
            var source = document.getElementById("nearestSearchTemplate").innerHTML;
            searchHandleBarsTemplate = Handlebars.compile(source);
            html = searchHandleBarsTemplate(resultCollection);
            $('#nearestSearchResults').html(html);
        }
    }
    // initAccordions();

    setTimeout(function () {
        $('.loading-overlay').addClass('loading-overlay--hide');
    }, 500);
}

function initLocalSearch() {
    //console.log('Raw cookie params : %o', Cookies.get(findNearestSearchType));

    searchParams = {};
    if (typeof Cookies.get(findNearestSearchType) !== 'undefined') {
        searchParams = JSON.parse(Cookies.get(findNearestSearchType));
    }
    //console.log('initLocalSearch params : %o', searchParams);

    var source = document.getElementById("nearestSearchTemplate").innerHTML;
    searchHandleBarsTemplate = Handlebars.compile(source);

    if (typeof searchParams.postcode !== 'undefined') {
        $('.content-area').addClass('loading-overlay');
        var prom = fetchSearchResults();
        var html = "";
        prom.then(

            function (result) {
                processResults(result);
            }

        );
    } else {
        //console.log('Show empty search template : %o', searchParams);

        // Show missing parameters
        var empty = document.getElementById("emptySearchTemplate").innerHTML;
        emptyTemplate = Handlebars.compile(empty);
        html = emptyTemplate(null);
        $('#nearestSearchResults').html(html);
    }
}

function fetchSearchResults() {
    //console.log("fetchSearchResults called");

    return new Promise(function (resolve, reject) {
        searchParams = buildServiceSearchParams('fetchSearchResults');
        if (searchParams.postcode === usingCurrentLocText) {
            searchParams.postcode = "Current";
        }

        var data = { serviceType: searchParams.service, postcode: searchParams.postcode };

        if (!(typeof searchParams.currentLat === 'undefined' || searchParams.currentLat === '' || searchParams.currentLat === 'NaN')) {
            // Only if it exists
            data.latitude = parseFloat(searchParams.currentLat).toFixed(6);
            data.longitude = parseFloat(searchParams.currentLong).toFixed(6);
        }

        // Switch url formats
        data.isNHSFife = isNHSFife;

        //console.log('Passing to GetNearestService controller : %o', data);
        //console.log(JSON.stringify(data));

        $.ajax({
            url: "/Umbraco/Surface/NSD/GetNearestService",
            method: 'post',
            data: jQuery.param(data)
        }).done(function (result) {
            if (result.errorMessage != null && result.errorMessage != "") {
                var source = document.getElementById("nearestSearchTemplateError").innerHTML;
                searchHandleBarsTemplate = Handlebars.compile(source);
                html = searchHandleBarsTemplate(result.errorMessage);
                $('#nearestSearchResults').html(html);
            }
            else {
                var nearestSearchResults = document.getElementById('nearestSearchResults');
                nearestSearchResults.innerHTML = result;
                scrollToAnchorIDOffset('nearestSearchResults');
            }
            resolve(result);
            console.log('done RESULT : %o', result);
        }).fail(function (result) {
            //console.log('Failed : %o', result);
            reject(result);
        });
    });
}

function buildServiceSearchParams(calledFrom) {
    searchParams = {};
    if ($('#localSearchPostcode').val() !== '') {
        searchParams.postcode = $('#localSearchPostcode').val();
    }
    if ($('#chooseservice').val() !== '') {
        searchParams.service = $('#chooseservice').val();
        searchParams.servicePretty = $('#chooseservice option:selected').attr('data-service');
    }
    if (searchParams.postcode.toUpperCase() === usingCurrentLocText.toUpperCase()) {
        if ($('#currentLat').val() !== '') {
            searchParams.currentLat = $('#currentLat').val();
        }
        if ($('#currentLong').val() !== '') {
            searchParams.currentLong = $('#currentLong').val();
        }
    } else {
        // Not a curretn search. Clear it out
        //console.log('Clearing lat long');
        $('#currentLat').val('');
        $('#currentLong').val('');
    }

    console.log(calledFrom + ' is setting Find your nearest cookie to %o', searchParams);
    Cookies.set(findNearestSearchType, JSON.stringify(searchParams), {
        //expires: 1 - Session cookie
    });
    return searchParams;
}